/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Cancel_ErrorInputs */

const vi_irrigation_run_cancel_error = /** @type {(inputs: Irrigation_Run_Cancel_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ phiên tưới thất bại`)
};

/**

* @param {Irrigation_Run_Cancel_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_cancel_error = /** @type {((inputs?: Irrigation_Run_Cancel_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Cancel_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_cancel_error(inputs)
});